import { motion, AnimatePresence } from "framer-motion";
import { type ReactNode } from "react";

interface SectionTransitionProps {
  children: ReactNode;
  isOpen: boolean;
}

const sectionVariants = {
  closed: {
    height: 0,
    opacity: 0,
  },
  open: {
    height: "auto",
    opacity: 1,
  },
};

export function SectionTransition({ children, isOpen }: SectionTransitionProps) {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          variants={sectionVariants}
          initial="closed"
          animate="open"
          exit="closed"
          transition={{
            duration: 0.3,
            ease: "easeInOut",
          }}
          style={{ overflow: "hidden" }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

